<div class="compliance-container">
	<div class="compliance-container-inner">
		<img
			class="d-none d-md-block orange-pattern-overlay"
			src="../../assets/img/orange-pattern.png"
			alt=""
		/>
		<img
			class="d-md-none orange-pattern-overlay"
			src="../../assets/img/orange-pattern-mobile.png"
			alt=""
		/>
		<div class="container text-center">
			<h2 class="compliance-header">
				Continuous Compliance for <br class="d-none d-sm-block" />
				Energy + Utilities
			</h2>

			<div class="row">
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/audit-protector.svg"
						alt=""
					/>
					<div class="challenges-list-head">Audit Protector</div>
					<div class="challenges-list-content">
						Secure your organization effectively and efficiently.
						Exceed the expectations of audits with all encompassing
						compliance information.
					</div>
				</div>
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/regulation-monitor.svg"
						alt=""
					/>
					<div class="challenges-list-head">Regulation Monitor</div>
					<div class="challenges-list-content">
						Remain up to speed on compliance rules and
						regulations. The NERC CIP regulations require that each
						Regional Entity be audited at least once every 5 years.
					</div>
				</div>
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/cost-reducer.svg"
						alt=""
					/>
					<div class="challenges-list-head">Cost Reducer</div>
					<div class="challenges-list-content">
						Free up your budget by removing your paperwork problem.
						Focus your efforts on actual cyber security
						improvements.
					</div>
				</div>
			</div>
			<a href="https://go.regscale.com/RegScale-Create-Account">
				<button class="complaince-button py-2 px-5 mt-2 mt-lg-5">
					Find Out More
				</button></a
			>
		</div>
	</div>
</div>
